import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const SoilMoistureCalibrationModal = ({
  show,
  onHide,
  sensor,
  loading,
  calibrationValues,
  sliderValues,
  currentRawReading,
  onSliderChange,
  onRefresh,
  onSave,
}) => (
  <Modal show={show} onHide={onHide} size="lg">
    <Modal.Header closeButton>
      <Modal.Title style={{ fontFamily: 'Orbitron' }}>
        Calibrate {sensor?.name || sensor?.sensorType} (Pin {sensor?.pin})
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {loading ? (
        <div className="text-center">Loading sensor data...</div>
      ) : (
        <>
          <div className="mb-4">
            <h5>Current Calibration Values:</h5>
            <p>Wet (Min): {calibrationValues.min} | Dry (Max): {calibrationValues.max}</p>
            <div className="d-flex align-items-center gap-2">
              <p className="mb-0"><strong>Current Raw Reading: {currentRawReading}</strong></p>
              <Button variant="outline-secondary" size="sm" onClick={onRefresh} disabled={loading}>
                {loading ? 'Refreshing...' : 'Refresh'}
              </Button>
            </div>
          </div>

          <div className="mb-4">
            <h5>Manual Calibration</h5>
            <Form.Group className="mb-3">
              <Form.Label>Analog Reading Range (0-4095)</Form.Label>

              <div className="mb-3">
                <Form.Label className="small">Wet Value (Sensor in Water)</Form.Label>
                <Form.Range
                  min={0}
                  max={4095}
                  value={sliderValues.min}
                  onChange={(e) => onSliderChange({ ...sliderValues, min: parseInt(e.target.value, 10) })}
                />
                <div className="d-flex justify-content-between text-muted small mt-1">
                  <span>0</span>
                  <span className="fw-bold">Wet: {sliderValues.min}</span>
                  <span>4095</span>
                </div>
              </div>

              <div className="mb-3">
                <Form.Label className="small">Dry Value (Sensor in Air)</Form.Label>
                <Form.Range
                  min={0}
                  max={4095}
                  value={sliderValues.max}
                  onChange={(e) => onSliderChange({ ...sliderValues, max: parseInt(e.target.value, 10) })}
                />
                <div className="d-flex justify-content-between text-muted small mt-1">
                  <span>0</span>
                  <span className="fw-bold">Dry: {sliderValues.max}</span>
                  <span>4095</span>
                </div>
              </div>
            </Form.Group>

            <div className="text-muted small mb-3">
              <strong>How to calibrate:</strong><br />
              - Place sensor in water and adjust the Wet Value slider to match the current raw reading<br />
              - Place sensor in air and adjust the Dry Value slider to match the current raw reading<br />
              - Save the values when you are satisfied with the calibration
            </div>
          </div>
        </>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onHide}>Cancel</Button>
      <Button variant="primary" onClick={onSave}>Save Calibration Values</Button>
    </Modal.Footer>
  </Modal>
);

export default SoilMoistureCalibrationModal;